// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Dtyczl2hzItTKzqbm_Sg{display:flex;align-items:flex-start;flex-wrap:wrap;gap:.5rem;width:100%}._MqyagJhTeMKPNrtsoH8{flex:1 1 auto;min-width:0}", "",{"version":3,"sources":["webpack://./src/p5lab/P5LabVisualizationColumn.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,sBAAA,CACA,cAAA,CACA,SAAA,CACA,UAAA,CAGF,sBACE,aAAA,CACA,WAAA","sourcesContent":[".gameButtonsRow {\n  display: flex;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  width: 100%;\n}\n\n.gameButtonsFlexItem {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gameButtonsRow": "Dtyczl2hzItTKzqbm_Sg",
	"gameButtonsFlexItem": "_MqyagJhTeMKPNrtsoH8"
};
export default ___CSS_LOADER_EXPORT___;
